import React, { memo } from 'react';
import { QuestionType, ViewMath }  from 'components/HHQComponents';

import { TestDetailQuizModel, TestQuestionAnswer } from "models/test-detail.model";
interface PropTypes {
    question: TestDetailQuizModel;
    answers: TestQuestionAnswer[];
    handleUpdateQuestions: (newValue: TestDetailQuizModel) => void;
}

const LuaChonComponent: React.FC<PropTypes> = ({ question, answers, handleUpdateQuestions }) => {
  return (
    <div>
      {(answers || []).map((answer, index) => (
        <div
          className="question-content--item choose-question"
          key={`answer${question.id}-${index}`}
        >
          <label
            htmlFor={`cb${question.id}${index}`}
            className="custom-checkbox latex-component"
          >
            <input
              type={question.testQuestionTypeCode === QuestionType.mot_lua_chon ? 'radio' : 'checkbox'}
              name={question.id}
              id={`cb${question.id}${index}`}
              defaultChecked={(question.userAnswer || []).includes(answer?.order)}
              value={answer.answer}
              onChange={(e) => {
                if (!Array.isArray(question.userAnswer)) {
                  question.userAnswer = [];
                }

                if (e.target.checked) {
                  if (question.testQuestionTypeCode === QuestionType.mot_lua_chon) {
                    question.userAnswer[0] = answer?.order;
                  } else {
                    question.userAnswer.push(answer?.order);
                  }
                } else {
                  const idx = question.userAnswer.findIndex((o: any) => o === answer?.order);
                  if (idx !== -1) {
                    question.userAnswer.splice(idx, 1);
                  }
                }

                handleUpdateQuestions({ ...question });
              }}
            />
            <ViewMath>
              <span dangerouslySetInnerHTML={{ __html: answer?.answer || '' }} />
            </ViewMath>
          </label>
        </div>
      ))}
    </div>
  );
};

export default memo(LuaChonComponent);
